export const HOSTNAME_PROJECT_CODE_MAP = {
  'fab.admin.staging.thriwe.com': 'FAB',
  // localhost: 'FAB', // temp for local testing — revert before commit
};

export const getHostnameProjectCode = () => HOSTNAME_PROJECT_CODE_MAP[window.location.hostname] ?? 'ADMIN_ACCESS';

export const isListedHostname = () => window.location.hostname in HOSTNAME_PROJECT_CODE_MAP;
